/**
 * Formats a date string into 'DD-MM-YYYY' format.
 * @param {string|null} dateString - The date string to format.
 * @returns {string} - Formatted date or 'N/A' if invalid.
 */

export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  if (isNaN(date)) return "N/A";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  if (isNaN(date)) return "N/A";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

export const convertUTCToLocalDatetimeLocal = (utcString) => {
  if (!utcString) return ""; // handle undefined/null gracefully

  const date = new Date(utcString);

  if (isNaN(date.getTime())) {
    console.error("Invalid date:", utcString);
    return "";
  }

  return date.toISOString().slice(0, 16); // returns "YYYY-MM-DDTHH:mm"
};
